import React, { useState } from "react";
import numeros from "numeros_a_palabras";

import Preview from './imprimir/preview';
import db from '../firebase-config'
import { collection, getDocs } from "firebase/firestore";
import './configuraciones/css/geo.css'

class NuevoPrestamo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 'Selecciona al cliente',
      cantidad: '',
      cantidadLetra: '',
      cantidadPagares: 6,
      array: [],
      show: true,
      inputAvals: true,

      avalNombre1: '',
      avalDomicilio1: '',
      avalNombre2: '',
      avalDomicilio2: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.cantidadChange = this.cantidadChange.bind(this);
    this.cantidadPagaresChange = this.cantidadPagaresChange.bind(this);

    this.checkAvales = this.checkAvales.bind(this)


    this.changeNombreAval1 = this.changeNombreAval1.bind(this)
    this.changeDomicilioAval1 = this.changeDomicilioAval1.bind(this)
    this.changeNombreAval2 = this.changeNombreAval2.bind(this)
    this.changeDomicilioAval2 = this.changeDomicilioAval2.bind(this)
    
    
  }
  async componentDidMount() {
    var data = [];
    var contador = 0;
    const datos = await getDocs(collection(db, 'clientes'))
    datos.forEach((documento) => {
      const clientedata = documento.data();
      console.log(clientedata);

      const obj = {
        id: contador,
        name: clientedata.nombre,
        tel: clientedata.telefono,
        direccion: clientedata.domicilio,
        colonia: clientedata.colonia
      }

      data.push(obj);
      contador = contador + 1;
    })
    this.setState({ array: data })
  }
  handleChange(event) {
    this.setState({ value: event.target.value });
  }
  // replacemiles(valor){
  //   var correccion = valor
  //   if(valor.includes('MIL'))
  //   {
  //     correccion = valor.replace("MIL", ' MIL ')
  //   }
  //   // if(valor.includes('DIEZMIL'))
  //   // {
  //   //    correccion = valor.replace("DIEZMIL", 'DIEZ MIL')
  //   // }
  //   // else if(valor.includes('DOSMIL'))
  //   // {
  //   //   correccion =  valor.replace("DOSMIL", 'DOS MIL')
  //   // }
  //   // else if(valor.includes('TREINTAMIL'))
  //   // {
  //   //   correccion =  valor.replace("TREINTAMIL", 'TREINTA MIL')
  //   // }
  //   // else if(valor.includes('CUATROMIL'))
  //   // {
  //   //   correccion =  valor.replace("CUATROMIL", 'CUATRO MIL')
  //   // }
  //   // else if(valor.includes('CINCOMIL'))
  //   // {
  //   //   correccion =  valor.replace("CINCOMIL", 'CINCO MIL')
  //   // }
  //   // else if(valor.includes('SEISMIL'))
  //   // {
  //   //   correccion =  valor.replace("SEISMIL", 'SEIS MIL')
  //   // }
  //   // else if(valor.includes('SIETEMIL'))
  //   // {
  //   //   correccion =  valor.replace("SIETEMIL", 'SIETE MIL')
  //   // }
  //   // else if(valor.includes('OCHOMIL'))
  //   // {
  //   //   correccion =  valor.replace("OCHOMIL", 'OCHO MIL')
  //   // }
  //   // else if(valor.includes('NUEVEMIL'))
  //   // {
  //   //   correccion =  valor.replace("NUEVEMIL", 'NUEVE MIL')
  //   // }
        
  //   return correccion;
  // }

  cantidadChange(event) {
    // console.log('VALOR CHANGE:');
    // console.log(event.target.value);
    let numero = 0
    numero = event.target.value
  
    numeros.numero2word().Config._setSingular("PESO");
    numeros.numero2word().Config._setPlural("PESOS");

    
    const letra = numeros.numero2word(numero).toString().replace("MIL", ' MIL ').toString().toUpperCase()
    var nueva = letra.replace('MIL LONES', 'MILLONES')
    var nueva2 = nueva.replace('MIL LON', 'MILLON')

    this.setState({ cantidadLetra: nueva2 });
    this.setState({ cantidad: event.target.value });
    
  }
  cantidadPagaresChange(event) {
    console.log(event.target.value);
    this.setState({ cantidadPagares: event.target.value });
  }
  Preview() {
    console.log('PREVIEW');
    this.setState({show: false})
  }

  checkAvales(){
    console.log('Check');
      
    if(this.state.inputAvals)
    {
      this.setState({inputAvals: false})
    }else
    {
      this.setState({inputAvals: true})
    }
  }

  //Avales
  changeNombreAval1(event){
    console.log(event.target.value);
    this.setState({avalNombre1: event.target.value})
  }
  changeDomicilioAval1(event){
    console.log(event.target.value);
    this.setState({avalDomicilio1: event.target.value})
  }
  changeNombreAval2(event){
    console.log(event.target.value);
    this.setState({avalNombre2: event.target.value})
  }
  changeDomicilioAval2(event){
    console.log(event.target.value);
    this.setState({avalDomicilio2: event.target.value})
  }


  render() {
    const handleClienteChange = (e) => {
      const nombre = e.target.value;
      const match = this.state.array.find(c => c.name === nombre);
      this.setState({ value: match || nombre });
    };

    if (this.state.array.length === 0)
      return (
        <p style={{ padding: '1rem', color: '#718096' }}>Cargando clientes...</p>
      );

    return (
      <div className="prestamo-form-grid">

        {/* ── Columna izquierda: datos del préstamo ── */}
        <div className="prestamo-card">
          <h2>Datos del préstamo</h2>

          <div className="form-field">
            <label>Cliente</label>
            <input
              list="clientes-list"
              type="text"
              placeholder="Escribe el nombre del cliente..."
              onChange={handleClienteChange}
            />
            <datalist id="clientes-list">
              {this.state.array.map(c => (
                <option key={c.id} value={c.name} />
              ))}
            </datalist>
          </div>

          <div className="form-field">
            <label>Total del préstamo ($)</label>
            <input
              type="number"
              placeholder="0.00"
              onChange={this.cantidadChange}
              min="0"
              step="0.01"
            />
            <div className="cantidad-en-letra">
              {this.state.cantidadLetra || 'El monto en letra aparecerá aquí'}
            </div>
          </div>

          <div className="form-field">
            <label>Cantidad de pagarés</label>
            <select defaultValue="6" onChange={this.cantidadPagaresChange}>
              {[1,2,3,4,5,6,7,8,9,10,11,12].map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>

          <label className="form-field-checkbox">
            <input type="checkbox" onClick={this.checkAvales} />
            <span>Agregar avales</span>
          </label>

          <Preview
            cliente={this.state.value}
            cantidad={this.state.cantidad}
            cantidadLetra={this.state.cantidadLetra}
            cantidadPagares={this.state.cantidadPagares}
            abrir={true}
            avalNombre1={this.state.avalNombre1}
            avalDomicilio1={this.state.avalDomicilio1}
            avalNombre2={this.state.avalNombre2}
            avalDomicilio2={this.state.avalDomicilio2}
            avales={this.state.inputAvals}
          />
        </div>

        {/* ── Columna derecha: avales ── */}
        {!this.state.inputAvals && (
          <div className="prestamo-card">
            <h2>Avales</h2>

            <p style={{ fontSize: '0.8rem', fontWeight: 600, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: '0.75rem' }}>Aval 1</p>

            <div className="form-field">
              <label>Nombre</label>
              <input type="text" placeholder="Nombre completo" onChange={this.changeNombreAval1} />
            </div>
            <div className="form-field">
              <label>Domicilio</label>
              <input type="text" placeholder="Domicilio" onChange={this.changeDomicilioAval1} />
            </div>

            <p style={{ fontSize: '0.8rem', fontWeight: 600, color: '#718096', textTransform: 'uppercase', letterSpacing: '0.04em', margin: '1rem 0 0.75rem' }}>Aval 2</p>

            <div className="form-field">
              <label>Nombre</label>
              <input type="text" placeholder="Nombre completo" onChange={this.changeNombreAval2} />
            </div>
            <div className="form-field">
              <label>Domicilio</label>
              <input type="text" placeholder="Domicilio" onChange={this.changeDomicilioAval2} />
            </div>
          </div>
        )}

      </div>
    );
  }
}

export default NuevoPrestamo;